<template>
  <section class="main">
    <div v-show="isLoading">
      <v-page-loading />
    </div>
    <div v-show="!isLoading">
      <div class="grid-container">
        <div class="action action--page">
          <button
            @click.prevent="getLastPage"
            :title="$t('nav.weeks')"
            class="button button--prev"
            tabindex="-1"
          >{{ $t('nav.weeks') }}</button>
          <h1>{{ getPageTitle }}</h1>
        </div>
      </div>
      <div class="grid-container">
        <div class="grid-x" v-if="this.$route.meta.method == 'update'">
          <div class="cell small-auto medium-7">
            <strong>{{ $t('kolonne.title') }}:</strong>
            {{ kolonne }}
            <strong>{{ $t('date') }}:</strong>
            {{ date | moment('DD.MM.YYYY') }}
            <div class="u-extra-small-margin--top" v-if="!isWeekend && daily_entries.length >= 1">
              <button
                class="button secondary"
                @click.prevent="saveAllEntries"
              >{{ $t('weeks.button.saveall')}}</button>
            </div>
          </div>
          <div class="cell small-auto medium-5 text-right">
            <button
              v-on:click.prevent="getPrevDay"
              role="button"
              type="submit"
              class="button button--prev button--calendar"
              :title="$t('backward')"
            >{{ $t('backward') }}</button>
            <button
              v-on:click.prevent="getNextDay"
              role="button"
              type="submit"
              class="button button--next button--calendar"
              :title="$t('forward')"
            >{{ $t('forward') }}</button>
          </div>
        </div>
        <div class="grid-x" v-if="!isWeekend">
          <div class="cell auto">
            <div class="c-day-planner" v-if="this.$route.meta.method == 'create'">
              <v-week-day-crud :method="createMethod" @refresh="refreshView"></v-week-day-crud>
            </div>
            <div class="c-day-planner" v-else>
              <div class="c-day-planner__add-button-wrapper text-center">
                <button
                  class="button button--action button--action--add-project"
                  @click.prevent="toggleCreateForm"
                  :title="$t('weeks.project.add')"
                >
                  <span class="show-for-sr">{{ $t('weeks.project.add') }}</span>
                </button>
              </div>
              <template v-if="insertCreateView">
                <v-week-day-crud :method="createMethod" @refresh="refreshView"></v-week-day-crud>
              </template>

              <div class="box u-no-padding" v-for="(entry, index) in sorted_entries" :key="index">
                <div v-for="(order, index) in weekday_sort_order" :key="index">
                  <div class="c-day-planner__index" v-if="entry.id == order.entry_id" title="Index">
                    <v-week-day-sort-input
                      :entryId="order.entry_id"
                      :sortOrder="order.sort_order"
                      @updateSortOrder="updateSortOrder"
                    ></v-week-day-sort-input>
                  </div>
                </div>

                <v-week-day-crud
                  :method="updateMethod"
                  :parentToSave="saveAll"
                  :entry="entry"
                  @refresh="refreshView"
                ></v-week-day-crud>
              </div>
            </div>
            <template v-if="this.$route.meta.method == 'update'">
              <div
                class="u-extra-small-margin--top u-extra-medium-margin--bottom"
                v-if="!isWeekend && daily_entries.length >= 1"
              >
                <button
                  class="button secondary"
                  @click.prevent="saveAllEntries"
                >{{ $t('weeks.button.saveall')}}</button>
              </div>
              <div v-if="daily_entries.length == 0">
                <h2 class="u-error text-center">{{ $t('no_results_found') }}</h2>
              </div>
            </template>
          </div>
        </div>
        <div
          v-else
          class="callout warning text-center u-extra-small-margin--top"
        >{{ $t('weeks.warning.weekend') }}</div>
      </div>
    </div>
    <v-dialog
      :isVisible="isVisible"
      :messageType="messageType"
      :content="dialogContent"
      v-model="isVisible"
    ></v-dialog>
  </section>
</template>

<script>
import PageHeader from "./../partials/PageHeader";
import PageLoading from "./../partials/PageLoading";
import WeekDayCrud from "./partials/weekDayCrud";
import WeekDaySortInput from "./partials/weekDaySortInput";
import Dialog from "./../partials/CommunicationDialog";
import _ from "lodash";

export default {
  name: "WeekDayList",
  data() {
    return {
      loading: false,
      saveAll: false,
      fieldsChanged: false,
      weekday_sort_order: [],
      createMethod: "create",
      updateMethod: "update",
      daily_entries: [],
      sorted_entries: [],
      weekday_object: [],
      date: this.$route.params.date || null,
      kolonne: this.$route.params.kolonne || null,
      insertCreateView: false,
      dateValid: true,
      isVisible: false,
      dialogContent: "",
      messageType: "default"
    };
  },
  components: {
    vPageHeader: PageHeader,
    vPageLoading: PageLoading,
    vWeekDayCrud: WeekDayCrud,
    vWeekDaySortInput: WeekDaySortInput,
    VDialog: Dialog
  },

  computed: {
    isLoading: function() {
      return this.loading;
    },
    getPageTitle: function() {
      return this.$t("weeks." + this.$route.meta.method + ".title");
    },
    isWeekend: function() {
      let isWeekend = false;
      if (this.date !== null) {
        let weekday = this.$moment(this.date).weekday();

        if (weekday === 5 || weekday === 6) {
          isWeekend = true;
        }
      }
      return isWeekend;
    }
  },
  mounted: function() {
    this.initView();
  },
  beforeRouteLeave(to, from, next) {
    // makes sure that when we leave this view that we reset the form state
    this.$store.dispatch("setFormReset");
    next();
  },
  methods: {
    /**
     * Sort Order Logic
     * Handling updating, saving, creating sort_order settings
     */

    initSortOrder: function() {
      // foreach daily entry, create an item in the sortorder array
      if (this.daily_entries.length === 0) {
        window.app.$helpers.logger("No daily_entries were found.");
        return;
      }

      this.daily_entries.forEach(item => {
        let obj = {
          entry_id: item.id,
          sort_order: 0
        };
        this.weekday_sort_order.push(obj);
      });

      this.reShuffleSortOrder();
    },

    updateSortOrder: function(payload) {
      // receives changed sort order information from child component

      // Find sort object by entry_id and update it if it already exists in the array.
      let itemPosition = this.weekday_sort_order.findIndex(
        el => el.entry_id == payload.entry_id
      );

      if (itemPosition !== -1) {
        this.weekday_sort_order[itemPosition] = {
          entry_id: payload.entry_id,
          sort_order: payload.sort_order
        };
      } else {
        window.app.$helpers.logger(
          "Sort order not found in array",
          payload.entry_id
        );
      }
    },

    reShuffleSortOrder: function() {
      this.sorted_entries = [];

      if (this.daily_entries.length >= 1) {
        window.app.$helpers.logger("Sorting started...");

        this.sorted_entries = _.sortBy(
          this.daily_entries,
          "sort_order",
          "desc"
        );

        window.app.$helpers.logger("Sorting ended...");
      }
    },

    addSortOrderToEntries: function() {
      this.daily_entries.forEach(item => {
        let match = this.weekday_sort_order.find(el => {
          if (item.id == el.entry_id) {
            return true;
          }
        });

        if (match !== undefined) {
          item.sort_order = parseInt(match.sort_order);
        }
      });
    },

    saveSortOrder: function() {
      // saves the SortOrder to the Weekday Object

      if (this.checkSortOrderForDuplicates()) {
        
        window.app.$helpers.logger("No duplicates found...");
        if (this.weekday_object.id !== undefined) {
          this.updateWeekDay();
        } else {
          this.createWeekDay();
        }
        return true;
      }
      
        window.app.$helpers.logger("Duplicates were found. Not saving weekday.");
        return false;
    },

    checkSortOrderForDuplicates: function() {
      let sortOrders = this.weekday_sort_order.map(value => {
        return value.sort_order;
      });

      if (new Set(sortOrders).size < this.weekday_sort_order.length) {
        this.isVisible = true;
        this.messageType = "error";
        this.dialogContent = this.$t("weeks.sorting.duplicates");
        return false;
      } else {
        return true;
      }
    },

    compareSortOrdertoEntries: function() {
      // Compare the database entries for sort order to the number of entries for this day.
      // If different, reset the weekday_sort_order and save to database
      // Referesh view
      window.app.$helpers.logger("Checking sort order...");

      let matches = [];

      if (this.daily_entries.length === this.weekday_sort_order.length) {
        window.app.$helpers.logger(
          "Array lengths checkout. Now comparing entries to sort order content..."
        );
        // Check if our ids are matching. If they dont' resave sort order based on daily_entries.

        this.daily_entries.forEach(item => {
          let match = this.weekday_sort_order.find(el => {
            if (item.id == el.entry_id) {
              return true;
            }
          });

          if (match !== undefined) {
            matches.push(match);
          }
        });

        if (this.daily_entries.length === matches.length) {
          window.app.$helpers.logger("Arrays are correct. Exiting.");
          return true;
        } else {
          window.app.$helpers.logger(
            "Matched arrays are not correct. Resaving sort order based on entries."
          );

          this.weekday_sort_order = [];
          this.daily_entries.forEach(item => {
            this.weekday_sort_order.push({
              entry_id: item.id,
              sort_order: 0
            });
          });

          window.app.$helpers.logger(
            "Reset our sort order. Now saving to database..."
          );

          this.saveSortOrder();
          return true;
        }
      }

      window.app.$helpers.logger(
        "Sorting order length does not match daily entries length, comparing and processing ..."
      );

      if (this.daily_entries.length < this.weekday_sort_order.length) {
        window.app.$helpers.logger(
          "We have less entries than in our sort order array. Clean up our sorting array ..."
        );

        this.daily_entries.forEach(item => {
          let match = this.weekday_sort_order.find(el => {
            if (item.id == el.entry_id) {
              return true;
            }
          });

          if (match !== undefined) {
            matches.push(match);
          }
        });
      } else if (this.daily_entries.length > this.weekday_sort_order.length) {
        window.app.$helpers.logger(
          "We have more entries than in our sort order array. Add these entries to our sorting array ..."
        );

        let missing_items = [];
        // loop through daily_entries. If an ID exists there but does not exist in the weekday_sort_oder, add it to the weekday_sort_order
        this.daily_entries.forEach(item => {
          let match = this.weekday_sort_order.find(el => {
            if (item.id == el.entry_id) {
              return true;
            }
          });

          if (match === undefined) {
            missing_items.push({
              entry_id: item.id,
              sort_order: 0
            });
          }
        });

        // merge missing_items with weekday_sort_order
        matches = [];
        window.app.$helpers.logger(
          "Missing items found ...",
          missing_items.length
        );
        matches = this.weekday_sort_order.concat(missing_items);
      }

      if (matches.length >= 1) {
        this.weekday_sort_order = [];
        this.weekday_sort_order = matches;
        window.app.$helpers.logger(
          "Updating database, saving sort order ...",
          matches
        );
        this.saveSortOrder();
      } else {
        window.app.$helpers.logger(
          "No matches found while checking sort order. Exiting.."
        );
      }
    },

    /**
     * Weekday object logic
     * - Getting current weekday object
     * - Creating if weekday object does not exist
     * - Updating weekday object with new sorting order
     */

    getWeekDay: function() {
      let promise = this.$api
        .clearParams()
        .addParam("date", this.$moment(this.date).format("YYYY-MM-DD 12:00:00"))
        .addParam("kolonne", this.kolonne)
        .get("weekday");

      promise
        .then(
          (response => {
            this.weekday_object = response.data.data;

            if (this.weekday_object.sort_order_items.length === 0) {
              this.initSortOrder();
            } else {
              this.weekday_sort_order = this.weekday_object.sort_order_items;

              this.compareSortOrdertoEntries();
              this.addSortOrderToEntries();
              this.reShuffleSortOrder();
            }
          }).bind(this)
        )
        .catch(
          (error => {
            if (error.response.status == 404) {
              // if there is no weekday object found, setup our sorting array anyway
              this.initSortOrder();
            } else {
              window.app.$helpers.logger(error.response);
            }
          }).bind(this)
        )
        .finally(() => {
          this.loading = false;
        });
    },

    createWeekDay: function() {
      window.app.$helpers.logger("Creating Weekday ...");

      let body = {
        kolonne: this.kolonne,
        date: this.$moment(this.date).format("YYYY-MM-DD"),
        sortOrderItems: this.weekday_sort_order
      };

      let promise = this.$api.clearParams().post("weekday", body);

      promise
        .then(
          (response => {
            this.initView();
          }).bind(this)
        )
        .catch(
          (error => {
            window.app.$helpers.logger(error);
          }).bind(this)
        );
    },

    updateWeekDay: function() {
      window.app.$helpers.logger("Updating Weekday ...");

      let body = {
        kolonne: this.kolonne,
        date: this.$moment(this.date).format("YYYY-MM-DD"),
        sortOrderItems: this.weekday_sort_order
      };

      let promise = this.$api
        .clearParams()
        .put("weekday/" + this.weekday_object.id + "/", body);

      promise
        .then(
          (response => {
            this.initView();
          }).bind(this)
        )
        .catch(
          (error => {
            window.app.$helpers.logger(error);
          }).bind(this)
        );
    },

    /**
     * Refresh View Logic
     * Called from child component (crud) when new entry has been added
     * Resets necessary variables for refreshing the view
     * Adds a sorting index to the new entry
     */

    refreshView: function(entryid, state) {
      if (entryid === undefined && state === undefined) {
        window.app.$helpers.logger(
          "No entry id or state was sent from child component."
        );
        return;
      }

      if (state == "create") {
        // Add new entry to beginning sorting array and save it if we are not deleting an entry
        let obj = {
          entry_id: entryid,
          sort_order: 0
        };
        this.weekday_sort_order.unshift(obj);
        
        // Update sorting index 
        this.weekday_sort_order.forEach((obj, index) => {
            obj.sort_order = index;
        })
        
        this.saveSortOrder();
      }

      if (state == "delete") {
        window.app.$helpers.logger("Deleting entry...");
        // find and remove this entry from the sort order array
        const itemPosition = this.weekday_sort_order.findIndex(
          el => el.entry_id == entryid
        );

        if (itemPosition !== -1) {
          this.weekday_sort_order.splice(itemPosition);
          this.saveSortOrder();
        } else {
          window.app.$helpers.logger(
            "No sort order item was found in the array while deleting."
          );
        }
      }

      // reset vars and refresh
      this.initView();
    },

    initView: function() {
      this.$store.dispatch("setFormReset");
      this.insertCreateView = false;
      this.saveAll = false;
      this.loading = true;
      this.daily_entries = [];
      this.weekday_sort_order = [];
      this.weekday_object = [];
      this.sorted_entries = [];

      if (
        this.$route.meta.method !== "create" &&
        this.$route.params.kolonne !== null &&
        this.$route.params.date !== null
      ) {
        if (this.$moment(this.$route.params.date).isValid()) {
          // read out of url and make api call based on kolonne and date
          this.getEntries();
        } else {
          window.app.$helpers.logger("Date is not valid.");
        }
      }

      if (this.$route.meta.method == "create") {
        this.loading = false;
      }
    },

    /**
     * Logic for getting entries
     */

    getEntries: function() {
      let promise = this.$api
        .clearParams()
        .addParam("currentdate", this.$moment(this.date).format())
        .addParam("kolonne", this.kolonne)
        .addParam("parked", 0)
        .addParam("byday", true)
        .get("weekplan");

      promise
        .then(
          (response => {
            if (response.data.data.length > 0) {
              this.daily_entries = response.data.data;

              this.getWeekDay();
            } else {
              window.app.$helpers.logger(
                "No daily_entries were found when getting entries ..."
              );
            }
          }).bind(this)
        )
        .catch(
          (error => {
            window.app.$helpers.logger(error);
          }).bind(this)
        )
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     *  Template Utiliites
     *  - day navigation
     *  - show and hide form for creating a new entry
     */
    getLastPage: function() {
      this.$store.dispatch("setFormReset");
      this.$router.replace({
        name: "weeks",
        params: { date: this.date }
      });
      this.loading = false;
    },

    getNextDay: function() {
      let newDate = this.$moment(this.date)
        .add(1, "day")
        .format("YYYY-MM-DD");
      this.$router.replace({
        name: "update-day",
        params: { date: newDate, kolonne: this.kolonne }
      });
      this.loading = false;
    },

    getPrevDay: function() {
      let newDate = this.$moment(this.date)
        .subtract(1, "day")
        .format("YYYY-MM-DD");
      this.$router.replace({
        name: "update-day",
        params: { date: newDate, kolonne: this.kolonne }
      });
      this.loading = false;
    },

    toggleCreateForm: function() {
      this.insertCreateView = !this.insertCreateView;
    },

    /**
     * This method checks and saves the sort order and it 
     * triggers the children watchers
     */
    saveAllEntries: function() {
      let orderSaved = this.saveSortOrder();
      if (orderSaved === true) {
        window.app.$helpers.logger("Saving all entries is triggered ...");
        this.saveAll = true;
      }
    }
  }
};
</script>